import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface Features {
  liga: boolean;
  saison: boolean;
  mannschaft: boolean;
}

interface FeaturesCtx {
  features: Features;
  reload: () => void;
}

const defaults: Features = { liga: true, saison: true, mannschaft: true };
const Ctx = createContext<FeaturesCtx>({ features: defaults, reload: () => {} });

export function FeaturesProvider({ children }: { children: React.ReactNode }) {
  const [features, setFeatures] = useState<Features>(defaults);

  const reload = useCallback(() => {
    apiClient.get('/api/features')
      .then(r => setFeatures({ ...defaults, ...r.data }))
      .catch(() => {});
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return <Ctx.Provider value={{ features, reload }}>{children}</Ctx.Provider>;
}

export function useFeatures() {
  return useContext(Ctx);
}
